<template>
  <!-- <f7-page class="AddContactGroup"> -->
  <div class="page">
    <bottom-toolbar></bottom-toolbar>
    <div class="page-content">
  		<page-nav-bar currentServiceName="MoneyRoad" subNavTitle="New Group" :returnPreviousPage="true" :menuAccess="true"></page-nav-bar>
      <div class="layoutTop"/>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <div class="panel21 panel-default">

                <div class="panel-heading">
                    <h4 class="content-block labelAccordionForm">
                        <i class="fa fa-address-book formIcon"></i>
                        Add Group
                    </h4>
                </div>

                <form>
                  <div class="form-group row">
                    <label class="col-5 col-sm-2 col-form-label"><span class="color-red">* </span>Group name</label>
                    <div class="col-7 col-sm-10">
                      <input class="form-control" type="text" placeholder="Group name" v-model="label"></input>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-5 col-sm-2 col-form-label test-title subtitleDebtorList">My contacts</label>
                    <div class="col-7 offset-sm-7 col-sm-3">
                      <a href="/account/addContactGroupContactList/">
                        <span href="#" class="button button-round button-inner-color">{{ this.selected.length }} selected</span>
                      </a>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-12" v-if="Object.keys(this.selectedDebtors).length > 0">Contacts in this group</div>
                  </div>
                  <div class="form-group row">
                    <ul class=" offset-sm-1 col-sm-10 list-group" v-if="Object.keys(this.selectedDebtors).length !== 0">
                      <li class="list-group-item" v-for="value in this.selectedDebtors" v-bind:key="value.id">{{value.label}}</li>
                    </ul>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 offset-md-9">
              <button round
              class="button-action firstButtonMarginTop"
              @click="addContactGroup">
                <i class="icon fa fa-save"></i>
                <span>Save</span>
              </button>
            </div>
          </div>
        </div>




      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
  <!-- </f7-page> -->
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'AddContactGroup',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data: () => {
    return {
      contactSelectionList: [],
      alias: '',
      username: '',
      contacts: [],
      selected: [],
      selectedDebtors: {},
      contactsObject: {},
      iban: '',
      label: ''
    }
  },
  created () {
    let that = this
    this.contacts = this.$engine.contacts.get()
    for (var i = 0; i < that.contacts.length; i++) {
      that.contactsObject[that.contacts[i].id] = that.contacts[i]
    }
    this.setContacts()
    that.$engine.settings.set({addContactGroupContactSelected: []})
    this.$bus.$on('refresh-add-contact-group-contact-selected', (data) => {
      that.selected = data
      that.changeItem()
    })
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    changeItem () {
      this.selectedDebtors = {}
      for (var i = 0; i < this.selected.length; i++) {
        this.selectedDebtors[this.selected[i]] = this.contactsObject[this.selected[i]]
      }
    },
    setContacts: function () {
      var contactList = {}
      for (var j = 0; j < this.$engine.contacts.get().length; j++) {
        var firstLetter = this.$engine.contacts.get(j).identifier.substr(0, 1).toUpperCase()
        if (!contactList.hasOwnProperty(firstLetter)) {
          contactList[firstLetter] = []
        }
        contactList[firstLetter].push({label: this.$engine.contacts.get(j).label, iban: this.$engine.contacts.get(j).iban, identifier: this.$engine.contacts.get(j).identifier, name: this.$engine.contacts.get(j).name, id: this.$engine.contacts.get(j).id, typeContact: this.$engine.contacts.get(j).typeContact})
        contactList[firstLetter].sort()
      }
      this.contactSelectionList = this.orderKeys(contactList)
    },
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    addContactGroup () {
      let that = this
      if (this.label !== '' && this.selected.length !== 0) {
        this.$engine.contacts
          .createContactGroup({
            idAccount: this.$engine.user.get().id,
            label: this.label,
            contacts: this.selected
          })
          .then(() => {
            that.$f7.alert('Contact Group added', 'Success', function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/contacts/'})
            })
          })
          .catch(err => {
            errorMessageAlert(err, this)
          })
      } else {
        if (this.label === '') {
          this.$f7.alert('', 'Invalid group name')
        } else {
          this.$f7.alert('', 'No contact selected')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CMAddContactGroup.vue?6b2fe118